<template>
  <b-row class="mb-1">
    <b-col md="6">
      <h4>Filtros</h4>
    </b-col>
    <b-col md="6" class="text-right">
      <b>Total de Membresías: </b> <b-badge variant="success" > {{memberships.length}} </b-badge>
    </b-col>

    <b-col md="2">
      <b-form-group>
        <label>Numero de registros</label>
        <v-select
          v-model="porPagina"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector"
          @input="changePerPage"
        />
      </b-form-group>
    </b-col>

    <b-col md="3">
      <b-form-group>
        <label>Buscar en tabla</label>
        <b-form-input
          v-model="filter.queryMembership"
          class="mr-1"
          placeholder="Search..."
          type="search"
        />
      </b-form-group>
    </b-col>

    <b-col md="1">
      <b-button
        @click="refreshData"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mt-2"
        :disabled="isLoadingSomething"
      > <feather-icon icon="RefreshCwIcon" style="color: white" />
      </b-button>
    </b-col>

    <b-col md="" v-if="can('fivesclub_membership_show_membership_add')">
      <div class="mt-2">
        <b-button
          :to="{name: 'create-membership'}"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right"
          v-b-tooltip.hover.left="'Dar de alta membresía'"
        > <feather-icon icon="PlusIcon" style="color: white" />
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { acl } from "@/modules/auth/mixins/acl"

export default {
	mixins: [acl],
  directives: {
    Ripple,
  },
  props:{
    perPage:{
      type: Number,
      required: true,
    },
    perPageOptions:{
      type: Array,
      required: true,
    },
    isLoadingSomething:{
      type: Boolean,
      required: true
    }
  },
  components: {
    vSelect,
  },
  data() {
    return {
      porPagina: this.perPage,
      statusFilter: null,
    }
  },
  computed:{
    ...mapState('fivesClubCatalogs', ['memberships','filter']),
  },
  methods:{
    changePerPage( perPage ){
      this.$emit('change-per-page', perPage)
      this.porPagina = perPage
    },
    refreshData(){
      this.$emit('refresh-data')
    }
  }
}
</script>